import Route from 'mewe/routes/route';

export default Route.extend({
  redirect: function () {
    this._super();
    window.location.href = '/';
  },
});
